import { useQuery } from '@tanstack/react-query';
import { getReadProvider } from 'modules/api';
import { useConnection } from 'modules/auth';
import { DEFAULT_VAULT_CHAIN_ID } from 'modules/common/const';
import { getShareValue } from '../sdk/getShareValue';

export const useShareValue = () => {
  const { chainId = DEFAULT_VAULT_CHAIN_ID } = useConnection();

  return useQuery({
    queryKey: ['shareValue', chainId],
    queryFn: async () => {
      const provider = await getReadProvider(chainId);
      return getShareValue(provider);
    },
  });
};
